import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ProfileCardWrapper = styled.section`
  font-size: 14px;
  color: #333;
  .chimName {
    font-size: 19px;
  }
  .aka {
    margin-top: -5px;
    font-size: 12px;
  }
  .mostRecentImg {
    margin: 4px 0 8px 0;
  }
  .status {
    margin-top: 6px;
    background-color: #f1f1f1;
    padding: 3px 7px;
  }
  .profileButton {
    position: absolute;
    top: 16px;
    right: 18px;
    a {
      color: #fff !important;
      text-decoration: none;
    }
    > button {
      font-size: 16px;
    }
  }
`;

function ProfileCard({ profile }) {
  const {
    full_name,
    chim_dir,
    aka,
    total_tracks,
    favorite_genre,
    location,
    most_recent_title,
    most_recent_img,
    vacation: status,
    member_since,
  } = profile;
  return (
    <ProfileCardWrapper>
      {most_recent_img !== "" && (
        <div className="mostRecentImg">
          <Link to={`/profile/${chim_dir}`}>
            <img src={most_recent_img} width="80" height="80" alt={most_recent_title} />
          </Link>
        </div>
      )}

      <div className="profileButton">
        <Link to={`/profile/${chim_dir}`}>
          <button className="btn btn-success">
            Profile
          </button>
        </Link>
      </div>
      <div className="chimName">
        <Link to={`/profile/${chim_dir}`}>
          <strong>{full_name} Chimney</strong>
        </Link>
      </div>
      {aka !== "" && (
        <div className="aka">
          <strong>AKA:</strong> {aka}
        </div>
      )}

      <div>
        <strong>Location:</strong> {location}
      </div>
      <div>
        <strong>Total Tracks:</strong> {total_tracks}
      </div>
      {favorite_genre && favorite_genre.genre && (
        <div>
          <strong>Musical Expertise:</strong> {favorite_genre.genre}
        </div>
      )}

      {status && status !== "" && (
        <div className="status">
          <strong>Status:</strong> {status}
        </div>
      )}
    </ProfileCardWrapper>
  );
}
export default ProfileCard;
